import { useAuth } from 'src/auth'

export const useLogoutOnUnauthorize = ({
  onError,
}: {
  onError?: (error) => void
} = {}) => {
  const { logOut } = useAuth()

  return async (error) => {
    if (error.message === `You don't have access to do that.`) {
      await logOut({
        logoutParams: {
          returnTo: window.location.origin,
        },
      })
    }

    if (onError) {
      onError(error)
    }
  }
}
